import styled from 'styled-components'

export const StyledCheckbox = styled.label`
  .checkbox-input {
    height: 20px;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${props => props.theme.fontSizes.extraSmall};
    border-radius: ${props => props.theme.borderRadius};
    background-color: #fff;

    svg {
      display: none;
      color: ${props => props.theme.colors.primary};
      height: 14px;
    }

    input {
      display: none;

      &:checked ~ svg {
        display: block;
      }
    }  
  }

  &.button {
    background: rgb(0, 161, 7);
    color: ${props => props.theme.colors.text};
    cursor: pointer;
    border-radius: ${props => props.theme.borderRadius};
    height: 40px;
    align-items: center;
    padding: 0 15px 0 10px;
    display: flex;
    color: #fff;

    .checkbox-input {
      display: inline-flex;
      margin: 0 7px 0 0;

      svg {
        color: rgb(0, 161, 7);
      }
    }

    .checkbox-text {
      display: inline-block;
      font-size: ${props => props.theme.fontSizes.small};
    }
  }
`
